import { SendParams } from 'types/sendTypes'
import { validateNickName } from 'validations/nicknameValidate'
import { sendNickname as sendAPI } from '../api/mail/sendPlayer'

export const sendPlayer = async ({ name, score }: SendParams) => {
  // const validatedEmail = validateNickName({ name, score })
  // if (validatedEmail.error) return validatedEmail
  return await sendAPI({ name, score })
}
